export const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4999"
    : "https://api.hireup.pro";

export const API_ENDPOINTS = {
  assessments: {
    list: "/assessments",
    create: "/assessments",
    extractPdf: "/assessments/extract/pdf",
    extractText: "/assessments/extract/text",
    generate: "/assessments/generate",
    invite: (id: string) => `/assessments/${id}/invite`,
    candidates: (id: string) => `/assessments/${id}/candidates`,
    deleteCandidates: "/assessments/candidates",
    take: (candidateId: string) => `/assessment/candidate/${candidateId}`,
    viewResponses: (candidateId: string) =>
      `/assessment/candidate/responses/${candidateId}`,
  },
  dashboard: {
    stats: "/dashboard",
  },
  general: {
    userData: "/general-data",
  },
} as const;
